'use client';

import type { ClassValue } from 'clsx';

import {
  ProductPanelTool,
  ProductPanelToolLabel,
  ProductPanelToolVariant,
  productPanelToolMarkVariants,
} from '@vs-shop/commerce-ui/productPanelTools';
import { DialogTrigger } from '@vs-shop/ui/dialog';
import { clsxm } from '@vs-shop/utils';
import { History } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  className?: ClassValue;
};

export default function ProductPriceHistoryTrigger({ className }: Props) {
  const intl = useIntl();

  return (
    <DialogTrigger
      render={
        <ProductPanelTool className={clsxm(className)}>
          <History
            className={clsxm(
              'size-5.5',
              productPanelToolMarkVariants({ variant: ProductPanelToolVariant.DEFAULT })
            )}
          />
          <ProductPanelToolLabel variant={ProductPanelToolVariant.DEFAULT}>
            {intl.formatMessage({
              id: 'productPanelToolPriceHistory.priceHistory',
              defaultMessage: 'Historie cen',
            })}
          </ProductPanelToolLabel>
        </ProductPanelTool>
      }
    />
  );
}
